import { Directive, ViewContainerRef, TemplateRef, Input, OnDestroy } from "@angular/core";
import { LaunchDarklyService } from "src/app/core/services/launch-darkly.service";
import { Subject, takeUntil, tap, of } from 'rxjs';

@Directive({
    selector: '[featureFlagIf]'
})
export class FeatureFlagDirective implements OnDestroy {
    protected destroy$: Subject<void> = new Subject<void>();
    constructor(private tpl: TemplateRef<any>, private vcr: ViewContainerRef, private launchDarklyService: LaunchDarklyService) {
    }

    @Input() set featureFlagIf(obj: { featureFlag: string, defaultFlag?: boolean }) {
        this.vcr.clear();
        this.renderFeature(obj);
    }

    renderFeature(obj: any): void {
        this.launchDarklyService.getFlag(obj.featureFlag, obj.defaultFlag).pipe(
            takeUntil(this.destroy$),
            tap(resp => {
                if (resp) {
                    this.vcr.createEmbeddedView(this.tpl);
                }
            })
        ).subscribe();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}